import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, custom, palette }: Theme) => ({
    modal: {
      maxWidth: 826,
      borderRadius: 16,
      padding: '32px 24px',
      textAlign: 'center',
      fontFamily: 'Lato',
    },
    modalHeading: {
      margin: '0 auto 16px',
      maxWidth: 600,
      fontFamily: 'Merriweather',
      fontSize: 40,
      color: custom.grey[3],
      [breakpoints.down('xs')]: {
        fontSize: 26,
      },
    },
    modalText: {
      marginBottom: 24,
      fontSize: 15,
      color: custom.grey[3],
    },
    redirectButton: {
      marginBottom: 24,
    },
    continueButton: {
      marginBottom: 8,
      borderRadius: 50,
    },
    separator: {
      marginBottom: 8,
      position: 'relative',
      textAlign: 'center',
      zIndex: 1,
      fontWeight: 'bold',
      '&:before': {
        position: 'absolute',
        zIndex: -1,
        content: '""',
        top: '50%',
        left: 0,
        height: 1,
        width: '100%',
        backgroundColor: custom.grey[13],
      },
    },
    separatorText: {
      display: 'inline-block',
      backgroundColor: palette.common.white,
      padding: '0 16px',
    },
    modalFooter: {
      fontSize: 14,
      color: custom.grey[17],
    },
    iconBoxes: {
      display: 'flex',
      marginBottom: 24,
      padding: '18px 0',
      '& > div:not(:last-of-type)': {
        borderRight: `1px solid ${custom.grey[13]}`,
      },
      [breakpoints.down('xs')]: {
        flexDirection: 'column',
        padding: '0 16px',
        '& > div:not(:last-of-type)': {
          borderRight: 'none',
          borderBottom: `1px solid ${custom.grey[13]}`,
        },
      },
    },
    iconBox: {
      flex: '1 1 50%',
      padding: '0 16px',
      minHeight: 126,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      [breakpoints.down('xs')]: {
        minHeight: 106,
        padding: '24px 0',
      },
    },
    iconBoxIcon: {
      marginBottom: 10,
    },
    iconBoxText: {
      maxWidth: 180,
      [breakpoints.down('xs')]: {
        maxWidth: 'initial',
      },
    },
  })
);
